import type {
  IGetRecommendModelTagParams,
  ICreateModelCollectionParams,
  IGetModelCollectionPageParams,
  IGetModelCollectionListParams,
  IGetModelOriginalInfoParams,
  IGetModelPageParams,
  ICreateModelParams,
  ILanguageTranslateParams,
  ICollectModelParams,
  ILikeModelParams,
  IGetModelCommentParams,
  ICreateModelCommentParams,
  ICreateModelReportParams,
  ICreateModelSettingParams,
  GetModelSettingParams,
  TopModelHandlerParams,
  GetModelPageParams,
  ModelHandlerParams,
  GeSelfModeParams,
  ISearchPageModelsParams,
  IThirdPartySearchPageModelsParams,
  IResModelCollectionPage,
  IResModelCollectionList,
  IRecommendPageModelsParams,
  IResRecommendPageModels,
} from "~/types/request/modelRequest.type";

// 首页推荐模型推荐来源 枚举
export enum RecommendSource {
  // 推荐模型
  RECOMMEND_MODEL = 1,
  // 配置模型
  CONFIG_MODEL = 2,
}

// 获得模型推荐标签分页  /api/v1/model-library-server/model-tag/recommend
export const getRecommendModelTag = (params: IGetRecommendModelTagParams) =>
  useGet("/api/v1/model-library-server/model-tag/recommend", params);

// 创建模型合集; /api/v1/model-library-server/model-collection/create
export const createModelCollection = (params: ICreateModelCollectionParams) =>
  usePost("/api/v1/model-library-server/model-collection/create", params);

// 获得模型合集  /api/v1/model-library-server/model-collection/get
export interface IgetModelCollectionDetailParams {
  id: number;
}
export const getModelCollectionDetail = (
  params: IgetModelCollectionDetailParams
) => useGet("/api/v1/model-library-server/model-collection/get", params);

export const getModelCollectionPage = (params: IGetModelCollectionPageParams) =>
  useGet(
    "/api/v1/model-library-server/model-collection/page",
    params
  ) as Promise<IResModelCollectionPage>;

// (访客）获得模型合集分页;
export const getVisitorModelCollectionPage = (
  userId: string,
  params?: IGetModelCollectionPageParams
) =>
  useGet(
    `/api/v1/model-library-server/model-collection/public/${userId}/page`,
    params
  ) as Promise<IResModelCollectionPage>;

/** 获取 自己创建的 模型合集(不分页) 列表 */
export const getModelCollectionList = (
  params?: IGetModelCollectionListParams
) =>
  useGet(
    "/api/v1/model-library-server/model-collection/list",
    params
  ) as Promise<IResModelCollectionList>;

/** 获取 自己收藏的 模型合集(不分页) 列表 */
export const getFavoriteModelCollectionList = () =>
  useGet(
    "/api/v1/model-library-server/model-collection/list/favorite"
  ) as Promise<IResModelCollectionList>;

/** (访客） 获取 创作者公开的 模型合集(不分页) 列表 */
export const getVisitorModelCollectionList = (
  userId: string,
  params?: IGetModelCollectionListParams
) =>
  useGet(
    `/api/v1/model-library-server/model-collection/public/${userId}/list`,
    params
  ) as Promise<IResModelCollectionList>;

// 爬取第三方链接网站信息  /api/v1/model-library-server/spider/originalInfo;
export const getModelOriginalInfo = (params: IGetModelOriginalInfoParams) =>
  usePost("/api/v1/model-library-server/spider/originalInfo", params);

// 获得模型分页 /api/v1/model-library-server/model-base-info/page;
export const getModelBaseInfoPage = (params: IGetModelPageParams) =>
  useGet("/api/v1/model-library-server/model-base-info/page", params);

// 获取分类树形数据 /api/v1/model-library-server/model-classification/tree;
export const getModelClassificationTree = () =>
  useGet(
    "/api/v1/model-library-server/model-classification/tree" +
      `?time=${new Date().getTime()}`
  );

// 最终步骤：上传模型 /api/v1/model-library-server/model-base-info/createOrUpdateBatch;
export const createOrUpdateBatch = (params: ICreateModelParams) =>
  usePost(
    "/api/v1/model-library-server/model-base-info/createOrUpdateBatch",
    params
  );

export const updateModel = (params: ICreateModelParams) =>
  usePut("/api/v1/model-library-server/model-base-info/update", params);

// 翻译富文本; (暂无用)
export const languageTranslate = (params: ILanguageTranslateParams) =>
  usePost("/api/v1/model-library-server/common/languageTranslate", params);

// #region 模型信息;
// 获取模型详情;
export const getModelDetail = (params: { id: string }) =>
  useGet("/api/v1/model-library-server/model-base-info/get", params);

// 获得编辑模型详情;  --同获取模型详情一致，不过是后端返回数据有做区别
export const getModelEditDetail = (params: { id: string }) =>
  useGet("/api/v1/model-library-server/model-base-info/getEditInfo", params);

// 收藏模型;
export const collectModel = (params: ICollectModelParams) =>
  usePost("/api/v1/model-library-server/model-base-info/collect", params);

// 点赞; /api/v1/model-library-server/model-base-info/like
export const like = (params: ILikeModelParams) =>
  usePost("/api/v1/model-library-server/model-base-info/like", params);

// 集合点赞-集合收藏: /api/v1/model-library-server/model-collection/like
export const collectionLike = (params: ILikeModelParams) =>
  usePost("/api/v1/model-library-server/model-collection/like", params);

// #endregion ;

// #region 模型评论;
// 获取模型评论; /api/v1/model-library-server/library/model-comment/commentTree
export const getModelComment = (params: IGetModelCommentParams) =>
  useGet(
    "/api/v1/model-library-server/library/model-comment/commentTree",
    params
  );

// 创建模型评论; /api/v1/model-library-server/library/model-comment/create
export const createModelComment = (params: ICreateModelCommentParams) =>
  usePost("/api/v1/model-library-server/library/model-comment/create", params);

// 删除模型评论; /api/v1/model-library-server/library/model-comment/delete
export const deleteModelComment = (params: { id: number | string }) =>
  useDelete(
    "/api/v1/model-library-server/library/model-comment/delete",
    params
  );

// 置顶评论; /api/v1/model-library-server/library/model-comment/top/{commentId}/{status}
export const topModelComment = (params: {
  commentId: number | string;
  status: boolean;
}) =>
  usePut(
    `/api/v1/model-library-server/library/model-comment/top/${params.commentId}/${params.status}`
  );
// #endregion ;

// 创建模型举报信息; /api/v1/model-library-server/library/model-report/create
export const createModelReport = (params: ICreateModelReportParams) =>
  usePost("/api/v1/model-admin-server/reports/submit", params);

// 创建模型设置 (打印配置)
export const createModelSetting = (params: ICreateModelSettingParams) =>
  usePost("/api/v1/model-library-server/model-setting/create", params);

// 修改模型设置 (打印配置)
export const updateModelSetting = (params: ICreateModelSettingParams) =>
  usePut("/api/v1/model-library-server/model-setting/update", params);

// 获取模型设置 (打印配置)
export const getModelSettingList = (params: GetModelSettingParams) =>
  useGet("/api/v1/model-library-server/model-setting/list", params);

// 获得模型设置 (打印配置)
export const getModelSetting = (params: { id: string }) =>
  useGet("/api/v1/model-library-server/model-setting/getEditInfo", params);

// 隐藏公开 模型设置 (打印配置)
export const openModelSetting = (params: TopModelHandlerParams) =>
  usePut(
    `/api/v1/model-library-server/model-setting/open/${params.id}/${params.status}`
  );

// 获得模型分页 /api/v1/model-library-server/model-base-info/page;
// 获取模型列表
export const getModelList = (params: GetModelSettingParams) =>
  useGet("/api/v1/model-library-server/model-base-info/list", params);

export const getHomePageModelList = (params: GetModelPageParams) =>
  useGet(
    "/api/v1/model-library-server/model-base-info/homePageModelList",
    params
  );

// 删除模型
export const deleteModelBaseInfo = (params: ModelHandlerParams) =>
  useDelete("/api/v1/model-library-server/model-base-info/" + params.id);

// 删除配置
export const deleteModelSetting = (params: ModelHandlerParams) =>
  useDelete("/api/v1/model-library-server/model-setting/" + params.id);

// 置顶、取消置顶
export const topModel = (params: TopModelHandlerParams) =>
  usePut(
    `/api/v1/model-library-server/model-base-info/top/${params.id}/${params.status}`
  );

// 隐藏、公开模型
export const openModel = (params: TopModelHandlerParams) =>
  usePut(
    `/api/v1/model-library-server/model-base-info/open/${params.id}/${params.status}`
  );

// 获取模型获取审核中/审核不通过/草稿列表列表
export const getSelfModelList = (params: GeSelfModeParams) =>
  useGet(
    "/api/v1/model-library-server/model-base-info/selfList/" + params.type
  );

// 搜索页模型分页列表;
// old api: /api/v1/model-library-server/model-base-info/searchPage
// new api: /api/v1/model-library-server/model-base-info/search
export enum SearchPageModelSortType {
  LATEST, // 最新;
  MOST_COLLECT, // 最多收藏;
  MOST_DOWNLOAD, // 最多下载;
}
export const getSearchPageModels = (params: ISearchPageModelsParams) =>
  useGet("/api/v1/model-library-server/model-base-info/search", params);

// 第三方模型搜索列表;
export const getThirdPartySearchPageModels = (
  params: IThirdPartySearchPageModelsParams
) => useGet("/api/v1/model-admin-server/thirdparty/page", params);

// 第三方模型详情; /api/v1/model-admin-server/thirdparty/get/{id}
export const getThirdPartyModelDetail = (params: { id: string }) =>
  useGet(`/api/v1/model-admin-server/thirdparty/get/${params.id}`);

// 后台预览待审批的模型;
export const getExamineModelInfo = (params: { id: string }) =>
  useGet(
    "/admin-api/library/model/getExamineModelInfo",
    { id: params.id },
    {
      isEnableBackend: true,
    }
  );

// 后台预览待审批的打印配置所属的模型信息;
export const getExamineSettingInfo = (params: { id: string }) =>
  useGet(
    "/admin-api/library/model/getExamineSettingInfo",
    { id: params.id },
    {
      isEnableBackend: true,
    }
  );

export const getBannerList = () =>
  useGet("/api/v1/model-admin-server/operation/banner/list");

// 本站模型推荐的模型;
export const getRecommendPageModels = (params: IRecommendPageModelsParams) =>
  useGet(
    "/api/v1/model-library-server/model-base-info/recommend",
    params
  ) as Promise<IResRecommendPageModels>;

// 获取模型页推荐;
export const getModelRecommend = (params: { id: string }) =>
  useGet(
    `/api/v1/model-library-server/model-base-info/${params.id}/recommend`,
    params
  );
